export default function lockProject(state, action) {
  return (
    Object.assign({}, state, {
      ui: {
        ...state.ui,
        modal: 'Locked'
      },
      locked: true
    })
  )
}



// WEBPACK FOOTER //
// ./src/reducers/lockProject.js